import React from 'react';

import V1Error from './V1Error';
import V2Error from './V2Error';

interface Props {
  error?: V1Error | V2Error;
}

export const ErrorWithFallbackMessage = () => (
  <section className="flex items-center justify-center w-full h-full p-6 bg-gray-100 overflow-auto">
    <div>
      <h1 className="text-base font-semibold">
        데이터를 불러오는 도중 문제가 발생했습니다.
      </h1>
    </div>
  </section>
);

const AppErrorFallback: React.FC<Props> = ({ error, ...rest }) => {
  if (error instanceof V1Error) {
    return (
      <section
        className="flex items-center justify-center w-full h-full p-6 bg-gray-100 overflow-auto"
        {...rest}
      >
        <div>
          <h2 className="text-base font-semibold">{error.error?.status} ERROR</h2>
          {error.error?.errors?.map((error, i) => (
            <p key={i} className="text-xs mt-1">
              {error.code} : {error.message}
            </p>
          ))}
        </div>
      </section>
    );
  }

  if (error instanceof V2Error) {
    return (
      <section
        className="flex items-center justify-center w-full h-full p-6 bg-gray-100 overflow-auto"
        {...rest}
      >
        <div>
          <h2 className="text-base font-semibold">
            [{error.error?.errorDomain?.toUpperCase() || 'ERROR'}]{' '}
            {error.error?.errorCode?.toUpperCase()}
          </h2>
        </div>
      </section>
    );
  }

  return <ErrorWithFallbackMessage />;
};

export default AppErrorFallback;
